<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-13 16:44:19
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-01 16:24:19
 * @Description: 自留地
-->
<template>
  <div class="home-private-items">
    <!-- 首页功能模块共用组件 -->
    <func-module
      title="自留地"
      icon="icon-ziliudi"
      titleColor="#588ef3"
      custom
      @hanleViewAll="getAllPrivateData"
    >
      <vuedraggable
        tag="ul"
        v-model="list"
        v-bind="dragOptions"
        filter=".profile"
        @start="dragStart"
        @end="dragEnd"
        @sort="handleSortChange"
      >
        <transition-group
          type="transition"
          :name="'flip-list'"
          class="private-item-panel"
        >
          <span
            v-for="item in list"
            :key="item.id"
            :style="`background-color:${moduleColor(item)}`"
            id="labal"
            @click="showLabalInfo(item)"
          >
            <div
              class="private-item-up iconfont"
              :class="item.icon"
              :style="`color:${moduleColor(item)}`"
            ></div>
            <div class="private-item-down">{{ item.name }}</div>
          </span>
          <span class="profile" key="profile" @click="showMyInfo()">
            <div class="private-item-up icon-ziliaoshouce iconfont"></div>
            <div class="private-item-down">资料</div>
          </span>
          <template v-if="showFillSpan">
            <span
              style="margin-top: 0;margin-bottom: 0;padding-top: 0;padding-bottom: 0;height: 0"
              v-for="item1 in 20"
              :key="item1 + 'index'"
            >
            </span>
          </template>
        </transition-group>
      </vuedraggable>

      <div class="empty-data" v-if="list.length === 0">
        <span
          class="empty-data-image"
          style="background-image: url('static/images/empty_data.png')"
        ></span>
        <span class="empty-data-text">暂无数据</span>
      </div>

      <div class="private-item-down"></div>
    </func-module>

    <animation
      :loadingDataVisible="
        !attachmentUploadState || !formInfoSaveState || isLoading
      "
      :loadingText="loadingText"
    ></animation>
  </div>
</template>
<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import vuedraggable from "vuedraggable";
import animation from "@/components/loading/animation";
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
import { mapState } from "vuex";
import FuncModule from "@/components/common/FuncModule";
export default {
  name: "PrivatePlotComponent",
  components: { animation, FuncModule, vuedraggable },
  data() {
    return {
      showTraditionalChinese: false,
      list: [],
      changeColor: [
        "#fbaf57",
        "#55a7f4",
        "#ff526e",
        "#5ed985",
        "#7772ec",
        "#5ed5d9",
        "#1e90ff",
        "#a29bfe",
        "#be2edd",
        "#3742fa"
      ],
      this_: this, //保存this以便filters中使用
      //true是结束,false是正在处理
      attachmentUploadState: true,
      //true是结束,false是正在处理
      formInfoSaveState: true,
      //灵敏度
      attachmentSensitive: 200,
      //默认span
      zldMenuspan: 6,
      loadingText: null,
      isLoading: false,

      //是否显示填充的空白的span块
      showFillSpan: false,
      dragOptions: {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    };
  },

  watch: {
    userPower: {
      immediate: true,
      handler(newVal) {
        //控制是否显示省中医的资料信息
        this.showTraditionalChinese = this.$store.state.userPowerStore.IS_GPHOTCM;
      }
    }
  },

  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower
    })
  },

  mounted() {
    this.showTraditionalChinese = this.$store.state.userPowerStore.IS_GPHOTCM;
    this.getLabel();
    this.initPage();
    // this.randomRgb(item);
    // this.randomRgb1(item);
  },

  //销毁时销毁监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeChange);
  },
  methods: {
    getAllPrivateData() {
      this.isLoading = true;
      this.$router
        .push({ path: "/privateplot/PrivatePlotList" })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //显示标签
    getLabel() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu", {
          token: token,
          data: {}
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              this.list = responseDate.data.eimsZldMenuList;
              this.$nextTick(() => {
                this.windowSizeChange();
              });
            }
          }
        });
    },

    showMyInfo() {
      this.isLoading = true;
      this.$router.push({ path: "/privateplot/member/basic" }).finally(() => {
        this.isLoading = false;
      });
    },
    //点击展开成果页面
    showLabalInfo(item) {
      if (item.name === "资料") {
        this.showMyInfo();
        return;
      }
      this.isLoading = true;
      const token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/Menu/main", {
          token,
          data: {
            parentId: item.id + ""
          }
        })
        .then(response => {
          const responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
              const res = responseDate.data.eimsZldMenuList;
              this.$router.push({
                path: "/privateplot/PaperList",
                query: { parentId: item.id, zldMenuId: res[0].id }
              });
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //点击展开成果页面
    // showLabalInfo(item) {
    //   this.isLoading = true;
    //   this.$router
    //     .push({
    //       path: "/privateplot/PrivatePlotList",
    //       query: { parentId: item.id }
    //     })
    //     .finally(() => {
    //       this.isLoading = false;
    //     });
    // },

    showScalingAnimation(id, obj) {
      let dom = document.getElementById(id);
      dom.setAttribute("class", "style_prevu_play");
      setTimeout(() => {
        dom.setAttribute("class", "style_prevu_stop");
        if (obj) {
          this.$router.push(obj);
        }
      }, 200);
    },
    initPage() {
      window.addEventListener("resize", this.windowSizeChange, false);
      this.windowSizeChange();
    },

    timeOutChange() {
      let that = this;
      if (this.spanTimeout !== null) {
        clearTimeout(this.spanTimeout);
        this.spanTimeout = null;
      }

      this.spanTimeout = setTimeout(() => {
        that.windowSizeChange();
      }, 10);
    },

    //窗口发生变化
    windowSizeChange() {
      let attachmentPanel = document.getElementsByClassName(
        "private-item-panel"
      )[0];
      let offsetHeight;
      if (attachmentPanel) {
        offsetHeight = attachmentPanel.offsetHeight;
      }
      if (offsetHeight > 200) {
        this.showFillSpan = true;
      } else {
        this.showFillSpan = false;
      }
    },
    dragStart(evt) {
      // debugger;
    },
    dragEnd(evt) {
      // debugger;
    },
    handleSortChange(val) {
      const newIndex = val.newIndex;
      const item = val.item._underlying_vm_;
      this.list.forEach((el, index) => {
        if (el.name === item.name) {
          el.seq = newIndex + 1;
        } else {
          if (el.seq >= newIndex + 1) {
            el.seq = index + 1;
          }
        }
      });
      // console.log(this.list);
      http
        .post(window.config.api.baseUrl + "/eims-api/zld/addSortMenu", {
          token: cookie.getCookie("token"),
          data: {
            idAndSeqs: this.list
          }
        })
        .then(response => {
          let responseDate = response.data;
          if (responseDate.code == "00000") {
            if (responseDate.data) {
            }
          }
        });
    },
    moduleColor(item) {
      switch (item.name) {
        case "成果": {
          return this.changeColor[0];
        }
        case "文库": {
          return this.changeColor[1];
        }
        case "活动": {
          return this.changeColor[2];
        }
        case "相册": {
          return this.changeColor[3];
        }
        case "证件": {
          return this.changeColor[4];
        }
        case "保险箱": {
          return this.changeColor[5];
        }
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-private-items {
  display: flex;
  flex-direction: column;
  height: 210px;
}

.private-item-panel {
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: space-around;
  align-items: center;
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  span {
    background-size: cover;
    background-image: url("/static/images/private-item.png");
    padding: 20px;
    text-align: center;
    margin: 5px 5px 5px 5px;
    display: inline-block;
    width: 100px;
    cursor: pointer;
    height: 130px;
    border-radius: 10px;
    z-index: 20;
  }
  .private-item-up {
    margin: 10px;
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50px;
    &:before {
      line-height: 40px;
      font-size: 30px;
    }
  }

  .private-item-down {
    width: 100%;
    color: white;
    font-weight: bold;
  }
  .icon-ziliaoshouce:before {
    color: rgb(252, 131, 97);
  }
}

.style_prevu_stop {
  display: inline-block;
  border: 0;
  width: 100px;
  height: 210px;
  position: relative;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(1);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(1);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(1);
  transition: all 200ms ease-in;
  transform: scale(1);
}

.style_prevu_play {
  animation-duration: 200ms;
  animation-name: transformBig;
  animation-fill-mode: forwards;
  top: calc(50vh - 75px);
  left: calc(50vw - 60px);
  position: fixed;
  box-shadow: 0px 0px 150px #000000;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(5);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(5);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(5);
  transition: all 200ms ease-in;
  transform: scale(5);
}

@keyframes transformBig {
  50% {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}

.profile {
  box-shadow: rgb(252, 131, 97) 0 1px 10px;
  background-color: rgb(252, 131, 97);
}
#labal {
  box-shadow: rgb(252, 131, 97) 0 1px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/PrivatePlotComponent.vue